import React from 'react';

export default class UserManagement extends React.Component
{
    render()
    {
        return (
            <div className="lmsdisplayarea">
                <h3>Manage Users</h3>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/user/usermanagement.js